import styled from '@emotion/styled'

export const Container = styled.div`
  align-items: center;
  color: rgba(0, 0, 0, 0.54);
  display: flex;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  gap: 0.5rem;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.15px;
`
